import angular from 'angular'

import { getElmStr } from './get-elm-str'
import { onTransitionEnd, offTransitionEnd } from './on-transition-end'

angular
  .module('ggs.utils')
  .factory('WaitTransitionEnd', WaitTransitionEndProvider)
  .factory('WaitTransitionEndQuiet', WaitTransitionEndQuietProvider)
  .factory('WaitTransitionEndSimpleInternal', WaitTransitionEndSimpleInternalProvider)
  .factory('WaitTransitionEndTimeoutInternal', WaitTransitionEndTimeoutInternalProvider)

const TIMEOUT_SKIP_APPLY = false

function WaitTransitionEndProvider($log, WaitTransitionEndSimpleInternal, WaitTransitionEndTimeoutInternal) {
  return function WaitTransitionEnd(...args) {
    return args.length === 3
      ? WaitTransitionEndTimeoutInternal($log.warn, ...args)
      : WaitTransitionEndSimpleInternal(...args)
  }
}

function WaitTransitionEndQuietProvider($log, WaitTransitionEndTimeoutInternal) {
  return function WaitTransitionEndQuiet(...args) {
    return WaitTransitionEndTimeoutInternal($log.debug, ...args)
  }
}

function WaitTransitionEndTimeoutInternalProvider($q, $timeout, WaitTransitionEndSimpleInternal) {
  return function WaitTransitionEndTimeoutInternal(log, allottedTime, $elm, propertyName) {
    let wait = true
    const event = WaitTransitionEndSimpleInternal($elm, propertyName)
    const timeout = $timeout(onTimeout, allottedTime, TIMEOUT_SKIP_APPLY)
    const deferred = $q.defer()
    event.then(onResolve, onReject)
    deferred.promise.kill = kill
    return deferred.promise

    function kill() {
      if (wait) {
        wait = false
        clear()
      }
    }

    function onTimeout() {
      if (wait) {
        wait = false
        clear()
        log(`WaitTransitionEnd#onTimeout: transition-end event triggered by "${propertyName}" property change didn't fire in ${allottedTime}ms for ${getElmStr($elm)}`)
        deferred.resolve($elm)
      }
    }

    function onResolve() {
      if (wait) {
        wait = false
        clear()
        deferred.resolve($elm)
      }
    }

    function onReject(err) {
      if (wait) {
        wait = false
        clear()
        deferred.reject(err)
      }
    }

    function clear() {
      event.kill()
      $timeout.cancel(timeout)
    }
  }
}

function WaitTransitionEndSimpleInternalProvider($q) {
  return function WaitTransitionEndSimpleInternal($elm, propertyName) {
    let wait = true
    const deferred = $q.defer()
    onTransitionEnd($elm, propertyName, flush)
    deferred.promise.kill = kill
    return deferred.promise

    function kill() {
      if (wait) {
        wait = false
        clear()
      }
    }

    function flush() {
      if (wait) {
        wait = false
        clear()
        deferred.resolve($elm)
      }
    }

    function clear() {
      offTransitionEnd($elm, propertyName, flush)
    }
  }
}
